import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root' // Ensures it is a singleton
})
export class Toast {
  private static toastrService: ToastrService;

    static init(toastr: ToastrService) {
    this.toastrService = toastr;
  }    //showSuccess('title')('message')
    static showSuccess = Toast.showToast('success');
    static showError = Toast.showToast('error');
    static showInfo = Toast.showToast('info');
    static showWarning = Toast.showToast('warning');

    static showToast(type: 'success' | 'error' | 'info' | 'warning') {
    return ({title = '', message = ''}: {title?:string, message?:string}) => {
      if (!this.toastrService) {
        console.error('ToastrService not initialized yet.');
        return;
      }

        switch (type) {
          case 'success':
            this.toastrService.success(message, title);
            break;
          case 'error':
            this.toastrService.error(message, title);
            break;
          case 'info':
            this.toastrService.info(message, title);
            break;
          case 'warning':
            this.toastrService.warning(message, title);
            break;
        }
      };
    };
  }




